import { RadioGroupProps } from "@hightouch/formkit";
import { SharedProps } from ".";
import { Controller } from "react-hook-form";
import { Badge, Radio, RadioGroup } from "@hightouch/htui";
import { Markdown } from "src/ui/markdown";
import { getIconComponent } from "src/formkit/utils";

export const FKRadioGroup = ({
  name,
  options,
  isDisabled,
  query,
}: RadioGroupProps & SharedProps) => {
  const staticOrDynamicOptions = query.enabled ? (query.data ?? []) : options;

  return (
    <Controller
      name={name}
      render={({ field }) => {
        // `RadioGroup` component requires values to be strings, but
        // field options can be either completely missing or be booleans
        // so we're using option indexes as `RadioGroup` value instead
        const selectedIndex = staticOrDynamicOptions.findIndex(
          (option) => option.value === (field.value ?? undefined),
        );

        return (
          <RadioGroup
            isDisabled={isDisabled}
            orientation="vertical"
            value={String(selectedIndex)}
            onChange={(indexString) => {
              const option = staticOrDynamicOptions.find(
                (_, index) => String(index) === indexString,
              );
              field.onChange(option?.value ?? null);
            }}
          >
            {staticOrDynamicOptions.map((option, index) => (
              <Radio
                key={option.value ?? index}
                description={
                  option.description && (
                    <Markdown>{option.description}</Markdown>
                  )
                }
                label={option.label}
                value={String(index)}
                badge={
                  option.badge ? (
                    <Badge
                      variant={option.badge.variant || "subtle"}
                      size={option.badge.size || "md"}
                      svgIcon={getIconComponent(option.badge.icon)}
                    >
                      {option.badge.text}
                    </Badge>
                  ) : undefined
                }
              />
            ))}
          </RadioGroup>
        );
      }}
    />
  );
};
